import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import { AngularFireDatabase } from 'angularfire2/database';

@Injectable({
  providedIn: 'root'
})
export class YouTubeService {

  maxResults: string = '10';
  pageToken: string;
  googleToken: string = 'AIzaSyDPVSrxqKQ4m-cFNVyV8LyN_pHXMKHpVUc';

  constructor(
    private db:AngularFireDatabase,
    private http: Http,
  ) {

  }

  getSearchResults(query) {
    let url = `https://www.googleapis.com/youtube/v3/search?part=id,snippet&part=contentDetails&q=${query}&type=video&order=viewCount&maxResults=${this.maxResults}&key=${this.googleToken}`;
    return this.http.get(url).map(res => res.json());
  }


  /**
   *  Pull info about video from YouTube
   */
  getVideo(videoId) {
    let url = `https://www.googleapis.com/youtube/v3/videos?part=contentDetails&id=${videoId}&key=${this.googleToken}`;
    return this.http.get(url).map(res => res.json());
  }


  /**
   *  Pull the video that was created in our Firebase db
   */
  getVideoFromFB(video) {
    let videoId;
    if(video.video_id) {
      videoId = video.video_id;
    } else {
      videoId = video;
    }
    return this.db.object(`/social/videos/${videoId}/`);
  }


  /**
   * Convert YouTube duration to standard
   */
  convertToStandardDuration(duration) {
    let array = duration.match(/(\d+)(?=[MHS])/ig)||[];

    let formatted = array.map(function(item){
        if(item.length<2) return '0'+item;
        return item;
    }).join(':');
    return formatted;
  }
}
